import * as Types from '../generatedTypes';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type AllEventAccountsQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type AllEventAccountsQuery = { __typename?: 'Query', eventAccounts?: Array<{ __typename?: 'EventAccount', id: string, name?: string | null }> | null };


export const AllEventAccountsDocument = gql`
    query allEventAccounts {
  eventAccounts {
    id
    name
  }
}
    `;

/**
 * __useAllEventAccountsQuery__
 *
 * To run a query within a React component, call `useAllEventAccountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllEventAccountsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllEventAccountsQuery({
 *   variables: {
 *   },
 * });
 */
export function useAllEventAccountsQuery(baseOptions?: Apollo.QueryHookOptions<AllEventAccountsQuery, AllEventAccountsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllEventAccountsQuery, AllEventAccountsQueryVariables>(AllEventAccountsDocument, options);
      }
export function useAllEventAccountsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllEventAccountsQuery, AllEventAccountsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllEventAccountsQuery, AllEventAccountsQueryVariables>(AllEventAccountsDocument, options);
        }
export type AllEventAccountsQueryHookResult = ReturnType<typeof useAllEventAccountsQuery>;
export type AllEventAccountsLazyQueryHookResult = ReturnType<typeof useAllEventAccountsLazyQuery>;
export type AllEventAccountsQueryResult = Apollo.QueryResult<AllEventAccountsQuery, AllEventAccountsQueryVariables>;